<template>
  <div id="card-download">
    <el-button @click="open = !open" class="btn-format">
      <span :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}`">{{quantidadeAnexos}} arquivos enviados</span>
      <inline-svg :class="{rotate : open}" style="float: right" :fill="estilo.aplicacao.corPrimariaAplicacao" height="12" :src="require('@/assets/icons/Arrow_chevron.svg')"></inline-svg>
    </el-button>
  <el-card v-show="open" :style="`background-color: ${estilo.aplicacao.corPrimariaAplicacao}0f`" class="card-download" v-for="(anexo, j)  in anexos" :key="j + 1">
    <span class="card-download-title">{{anexo.descricao}}</span>
    <el-button class="btn-card-downnload" @click="download(anexo.url)" type="text">
      <span class="btn-title">Downolad</span>
      <inline-svg fill="#006FB9" height="12" style="position: relative; bottom: 4px" :src="require('@/assets/icons/Icon_file_download.svg')">
      </inline-svg>
    </el-button>
  </el-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import inlineSvg from 'vue-inline-svg'
export default {
  data () {
    return {
      open: false
    }
  },
  props: {
    anexos: {
      type: Array
    }
  },
  components: {
    inlineSvg
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    quantidadeAnexos () {
      if (this.anexos) {
        return this.anexos.length
      }
      return ''
    }
  },
  methods: {
    download (url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="less">
#card-download {
  .btn-format {
    padding: 0;
    margin: 0;
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    text-transform: none;
    font-weight: 500;
    font-size: 14px;
  }
  .rotate {
    transform: rotate(90deg);
  }
}
</style>
